import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import {
	Button,
	Dialog,
	DialogClose,
	DialogContent,
	DialogFooter,
	DialogOverlay,
} from '@/app/shared/components';
import { setVisibleWarning } from '@/core/redux/slices';
import { useCustomDispatch, useCustomSelector } from '@/core/redux/hooks';
interface ModalInfoProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}
export const ModalInfo: React.FC<ModalInfoProps> = ({
	isOpen,
	onClose,
}: ModalInfoProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();
	const dispatch = useCustomDispatch();

	/*********************
	// #region Redux
	**********************/
	const { new_diamonds_collected } = useCustomSelector(
		(state) => state.counter
	);
	const { vtnAmount } = useCustomSelector((state) => state.user);

	/*********************
	// #region Functions  
	**********************/
	const handleCloseDialog = () => {
		onClose(false);
		dispatch(setVisibleWarning(false));
	};
	// Handle checkbox change

	/*********************
	// #region Template
	**********************/
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogOverlay className="bg-customer-950/90" />
			<DialogContent className="border-none bg-transparent">
				<div className="flex flex-col items-center space-x-2">
					<img
						src={process.env.VITE_END_SEASON_IMAGE}
						className="max-w-[280px]"
						alt={t('endSeason.one.description')}
					/>

					<h2 className="text-xl font-bold my-3">
						{t('endSeason.one.title')}
					</h2>

					<p className="text-sm text-left font-bold mb-2">
						{t('endSeason.one.description')}
					</p>

					<p className="text-sm text-left font-bold">
						{t('endSeason.one.description2')}
					</p>

					<div className="flex justify-around items-center my-4 mx-4 w-full">
						<div className="flex flex-col gap-2 items-center justify-center">
							<img
								src={process.env.VITE_VTN_IMAGE}
								className="max-w-[50px]"
								alt="VTN Generated from Airdrop Season 1"
							/>

							<p className="text-sm text-left font-bold">
								{vtnAmount.toFixed(2)}
							</p>
						</div>

						<div className="flex flex-col gap-2 items-center justify-center">
							<img
								src={process.env.VITE_MINI_DIAMOND_IMAGE}
								className="max-w-[50px]"
								alt="Diamonds generated from Airdrop Season 1"
							/>

							<p className="text-sm text-left font-bold">
								{new_diamonds_collected}
							</p>
						</div>
					</div>

				</div>

				<DialogFooter className="sm:justify-start">
					<DialogClose asChild>
						<Button
							type="button"
							variant="primary"
							onClick={handleCloseDialog}
							className="py-6 w-full flex items-center gap-1 text-sm rounded-lg"
						>
							{t('general.thanks')}
						</Button>
					</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
